<template>
  <div class="goldBg" v-if="slides">
    <div class="container">
      <div class="carousel">
        <transition-group name="fade">
          <slide 
            v-for="(slide, index) in slides" 
            :slide="slide"
            :index="index" 
            :key="index" 
            v-show="index === currentSlide" 
            :class="index === currentSlide ? 'active' : ''"
          ></slide>
        </transition-group>
        <div class="pager" v-if="slides.length > 1">
          <button 
            v-for="(slide, index) in slides"
            :key="index"
            class="btn btn-sm"
            :class="index === currentSlide ? 'active' : ''"
            @click="goToThisSlide(index)"
          >
            {{ index }}
          </button>
        </div>
        <div class="controls" v-if="slides.length > 1">
          <button @click="prevSlide()"><img src="~assets/images/PFK_Arrow_Carousel_Left.svg" width="40" height="40"></button>
          <button @click="nextSlide()"><img src="~assets/images/PFK_Arrow_Carousel_Right.svg" width="40" height="40"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slide from '../layouts/Slide'

export default {
  name: 'carousel',
  components: {
    Slide
  },
  props: ['slides'],
  data () {
    return {
      currentSlide: 0
    }
  },
  methods: {
    nextSlide () {
      let vm = this
      let index = vm.currentSlide + 1
      if (index + 1 > vm.slides.length) {
        vm.currentSlide = 0
      } else {
        vm.currentSlide = index
      }
    },
    prevSlide () {
      let vm = this
      let index = vm.currentSlide - 1
      if (index < 0) {
        vm.currentSlide = vm.slides.length - 1
      } else {
        vm.currentSlide = index
      }
    },
    goToThisSlide (index) {
      this.currentSlide = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

.container {
  @extend %noPadContainer;
}
</style>



// WEBPACK FOOTER //
// Carousel.vue?0e2dd4f6